<template>
    <v-btn
            v-if="smallBtn"
            color="#fff"
            rounded
            small
            fab
            outlined
            depressed
            :disabled="disabled === true || (!isFBReady || loading)"
            @click="login">
        <v-icon color="#fff" size="22">fab fa-facebook</v-icon>
    </v-btn>
    <v-btn
            v-else
            color="transparent"
            :rounded="round !== false"
            depressed
            :disabled="disabled === true || (!isFBReady || loading)"
            @click="login">
        <v-icon color="#3b5998" size="22">fab fa-facebook</v-icon>
        <span class="ml-2">{{text || 'Ingresar con Facebook'}}</span>
    </v-btn>
</template>

<script>
    import Vue from 'vue'
    import {ApiUtils} from '@/utils/ApiUtils'
    export default{
        props: [
            'round',
            'icon',
            'text',
            'disabled',
            'scopes',
            'small'
        ],
        data(){
            return {
                isFBReady: false,
                loading: false
            }
        },
        computed: {
            smallBtn(){
                var vm = this
                return vm.small !== undefined && vm.small !== false
            }
        },
        mounted(){
            this.isFBReady = Vue.fb != undefined
            window.addEventListener('fb-sdk-ready', this.onFBReady)
        },
        methods: {
            onFBReady(){
                this.isFBReady = true
            },
            login(){
                var vm = this
                vm.loading = true
                Vue.fb.login(async function(response) {
                    vm.loading = false
                    if (response.authResponse) {
                        vm.$emit('success', response.authResponse)

                    } else {
                        vm.$emit('cancelled', response)
                    }
                }, {scope: vm.scopes || 'email'});

            }
        }
    }
</script>
